// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__F3Ohb","title":"styles_title__-aG2A","date":"styles_date__eC893"};